// Dev Note: the load Google Tag Manager is done in public index.html

export const googleAdsSettings = {
  sendGoogleAdsConversionEvent: (): void => {
    (window as any).gtag('event', 'conversion', {'send_to': 'AW-772061391/YjMtCKie86wBEM_xkvAC'});
  },
};
